// extracted by mini-css-extract-plugin
export var productImage = "_xj-0";